<svg width="23" height="23" viewBox="0 0 23 23" fill="none" xmlns="http://www.w3.org/2000/svg">
<g clip-path="url(#clip0_2251_4497)">
<path fill-rule="evenodd" clip-rule="evenodd" d="M8 5.67175C4.68629 5.67175 2 8.35804 2 11.6718C2 14.9855 4.68629 17.6718 8 17.6718H15C18.3137 17.6718 21 14.9855 21 11.6718C21 8.35804 18.3137 5.67175 15 5.67175H8ZM8.53789 10.9717C8.15129 10.9717 7.83789 11.2851 7.83789 11.6717C7.83789 12.0583 8.15129 12.3717 8.53789 12.3717H14.462C14.8486 12.3717 15.162 12.0583 15.162 11.6717C15.162 11.2851 14.8486 10.9717 14.462 10.9717H8.53789Z" fill="currentColor"/>
</g>
<defs>
<clipPath id="clip0_2251_4497">
<rect width="22" height="22" fill="white" transform="translate(0.5 0.671753)"/>
</clipPath>
</defs>
</svg>
